import React from 'react'
import { Eye, Globe2 } from 'lucide-react'
import Seo from '../../components/Seo'

const PublicValuationLayout = ({ valuation, viewMode = 'shared', title, description: customDescription, image, children }) => {
  const demoMode = viewMode === 'demo'
  const description = customDescription || (valuation
    ? `${valuation.address} · ${valuation.layout} · ${valuation.m2} m² · odhad ${Math.round(valuation.anchorPrice || 0).toLocaleString('cs-CZ')} Kč`
    : demoMode
      ? 'Ukázková analýza nemovitosti'
      : 'Sdílený odhad nemovitosti')
  const StatusIcon = demoMode ? Eye : Globe2

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900">
      <Seo
        title={title || (valuation?.address ? `${demoMode ? 'Ukázková analýza' : 'Odhad'} ${valuation.address}` : demoMode ? 'Ukázková analýza' : 'Sdílený odhad')}
        description={description}
        image={image}
        noindex
        referrerPolicy={demoMode ? 'strict-origin-when-cross-origin' : 'no-referrer'}
      />
      <header className="border-b border-gray-200 bg-white shadow-sm">
        <div className="mx-auto flex max-w-screen-2xl flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-6">
          <a href="https://www.realitni-jestrab.cz/" className="flex items-center gap-3" aria-label="Realitní Jestřáb">
            <img src="/favicon.svg?v=2" alt="" className="h-9 w-9" />
            <div>
              <div className="text-base font-semibold text-gray-900">Realitní Jestřáb</div>
              <div className="text-xs text-gray-500">{demoMode ? 'Ukázková analýza' : 'Odhad nemovitosti'}</div>
            </div>
          </a>
          <div className="inline-flex items-center gap-2 rounded-full border border-green-200 bg-green-50 px-3 py-1.5 text-xs font-medium text-green-800">
            <StatusIcon className="h-4 w-4" />
            {demoMode ? 'Veřejná ukázka · pouze ke čtení' : 'Sdílený odhad · pouze ke čtení'}
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-screen-2xl">{children}</main>
    </div>
  )
}

export default PublicValuationLayout
